import OpenLayersTileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import { AttributionLike } from 'ol/source/Source';
import { useEffect, useRef } from 'react';
import { useBaseElement } from './useElement';
import { fetchTileWithRefreshControl } from './Tiling/tileLoadFunction';

interface OSMTileLayerProps {
  attributions?: AttributionLike;
  url?: string;
  headers?: Record<string, string>;
}

export function OSMTileLayer({
  attributions,
  url,
  headers,
}: OSMTileLayerProps) {
  const elementRef = useRef(
    new OpenLayersTileLayer({
      source: new OSM({
        attributions,
        url,
        tileLoadFunction: fetchTileWithRefreshControl(300, headers, 5),
      }),
      zIndex: 0,
    })
  );

  useBaseElement(elementRef.current, 'osm');

  useEffect(() => {
    if (attributions == null) {
      return;
    }
    elementRef.current.getSource()?.setAttributions(attributions);
  }, [attributions]);

  useEffect(() => {
    if (url == null) {
      return;
    }
    elementRef.current.getSource()?.setUrl(url);
  }, [url]);

  return null;
}
